import { View } from "@react-pdf/renderer"
import { colors } from "../../../src/config/theme"
import { QuestionData } from "../../config/questions"
import Text from "./Text"

export type QuestionPageProps = {
  text?: string
  idx: number
  question: QuestionData
}

const QuestionPage = ({
  text,
  children,
  idx,
  question,
}: QuestionPageProps & {
  children: JSX.Element
}) => {
  const number =
    question.number && Number(question.number) <= 9
      ? `0${question.number ?? idx + 1}`
      : question.number ?? idx + 1

  return (
    <>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          marginBottom: 12,
        }}
      >
        <Text
          style={{
            position: "relative",
            top: -3,
            flexGrow: 0,
            fontSize: 22,
            fontWeight: 700,
            lineHeight: 1.37,
            color: colors.greyMid,
          }}
        >
          {number}
        </Text>
        <Text
          style={{
            flex: 1,
            fontSize: 14,
            letterSpacing: 0.02,
            marginLeft: 16,
          }}
        >
          {text}
        </Text>
      </View>
      {children}
    </>
  )
}

export default QuestionPage
